'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var TrackingNumber_module = require('./TrackingNumber.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const TrackingNumber = props => {
  const {
    featureName,
    carrier,
    carrierLogoUrl
  } = props;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: TrackingNumber_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: TrackingNumber_module["default"].imgWrapper
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    className: TrackingNumber_module["default"].carrierImg,
    src: carrierLogoUrl,
    alt: carrier
  })));
};

exports["default"] = TrackingNumber;
